import React from "react";
import "./FilterTabs.css";

const FilterTabs = ({
  tabs,
  activeKey,
  onChange,
  ariaLabel = "Filter tabs",
  className = "",
  tabClassName = "",
  activeClassName = "is-active",
}) => {
  const listClassName = ["filter-tabs", className].filter(Boolean).join(" ");

  return (
    <div className={listClassName} role="tablist" aria-label={ariaLabel}>
      {tabs.map((tab) => {
        const isActive = activeKey === tab.key;
        const buttonClassName = ["filter-tabs-button", tabClassName, isActive ? activeClassName : ""]
          .filter(Boolean)
          .join(" ");

        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={buttonClassName}
            onClick={() => onChange(tab.key)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default FilterTabs;
